import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    MessageScrollerRootDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../types";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column",
        flexShrink: 1,
        minHeight: 0,
        flexGrow: 1,
        minWidth: 0
    },
    main: {
        flexDirection: "column",
        position: "relative",
        flexShrink: 1,
        flexGrow: 1,
        minHeight: 0
    }
});

export const useStyles = ({
    fadeColor
}: MessageScrollerRootDynamicStyleType) => {
    const styles = {
        container: {
            backgroundColor: fadeColor
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
